<mat-card>
    <!-- <mat-card-title style="  font-size: 1.8rem; font-weight: 700; margin-top: -4%;">Global Hits</mat-card-title> -->
    <!-- <div id="globediv"></div> -->
</mat-card>